import { render, staticRenderFns } from "./AllMessage.vue?vue&type=template&id=ecd1e120&scoped=true"
import script from "./AllMessage.vue?vue&type=script&lang=js"
export * from "./AllMessage.vue?vue&type=script&lang=js"
import style0 from "./AllMessage.vue?vue&type=style&index=0&id=ecd1e120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd1e120",
  null
  
)

export default component.exports